import { useQuery } from '@tanstack/react-query';
import { siteSettingsApi } from '@features/admin/settings/api/siteSettingsApi';

export const useSiteSettings = () => {
    return useQuery({
        queryKey: ['siteSettings'],
        queryFn: siteSettingsApi.getSettings,
        staleTime: 1000 * 60 * 30, // 30 minutes
    });
};
